import CheckCircle2Icon from '../../icons/CheckCircle2Icon.jsx';
import { useContext } from 'react';
import { ConfirmationContext } from '../../../lib/ConfirmationContext.js';
import EventDetails from './components/EventDetails.jsx';
import SafeHtml from '../../SafeHtml.jsx';
import UsedPackageGrantDetails from './components/UsedPackageGrantDetails.jsx';
import { QuestionType } from '~/lib/Questions';
import PublicGiftCertificatesList from '~/components/giftcertificates/PublicGiftCertificatesList';
import { clearSavedPaymentParams } from '~/public/components/FormPaymentFormWithSavedParams.jsx';

export function redirectFromThankYou(redirectUri) {
    if (redirectUri) {
        const protocol = redirectUri.substring(0, 5).toLowerCase();
        if (protocol === 'http:' || protocol === 'https') {
            try {
                window.top.location.href = redirectUri;
                return true;
            } catch (e) {
                // ...might just be permissions, fallback to redirecting current page
            }
            document.location.href = redirectUri;
            return true;
        }
    }

    // for (const s of sections) {
    //     for (const q of s.questions) {
    //         if (q.type === QuestionType.ThankYou) {
    //             const redirectUri = q.settings?.redirectUri || '';
    //             const protocol = redirectUri.substring(0, 5).toLowerCase();
    //             if (
    //                 redirectUri &&
    //                 (protocol === 'http:' || protocol === 'https')
    //             ) {
    //                 document.location.href = redirectUri;
    //             }
    //         }
    //     }
    // }

    return false;
}

const ThankYouTemplate = ({ title, description, settings, hideCheckmark }) => {
    return (
        <div>
            {!(settings?.hideCheckmark || hideCheckmark) && (
                <div className="flex items-center justify-center">
                    <div className="thank-you-check-container">
                        <CheckCircle2Icon className="w-32 h-32" />
                    </div>
                </div>
            )}

            <h1 className="text-2xl sm:text-4xl pt-6 text-center">{title}</h1>
            <div className="py-6 text-center">
                <SafeHtml html={description} />
            </div>
        </div>
    );
};

const BookingThankYou = ({
    events,
    submission,
    usedGrants,
    giftCertificates,
    settings,
}) => {
    const areAllEventsCanceled = events.every(ev => ev.canceled_at);

    let title = settings?.title;
    if (!title) {
        // User did not customize the title, give defaults and nicer one for cancellation
        if (areAllEventsCanceled) {
            title = 'Your appointment was canceled';
        } else {
            title = 'Thank you, your appointment is confirmed!';
        }
    } else if (areAllEventsCanceled) {
        // User customized the title, omit it on cancellation
        title = '';
    }

    return (
        <div>
            <ThankYouTemplate
                title={title}
                description={
                    settings?.description ||
                    'You will receive an appointment confirmation email with details of your booking.'
                }
                hideCheckmark={settings?.hideCheckmark || areAllEventsCanceled}
                settings={settings}
            />
            {!!usedGrants?.length && (
                <UsedPackageGrantDetails
                    grants={usedGrants}
                    token={submission.token}
                />
            )}
            {!!giftCertificates?.length && (
                <PublicGiftCertificatesList
                    giftCertificates={giftCertificates}
                    token={submission.token}
                />
            )}
            <EventDetails
                events={events}
                token={submission.token}
                form={submission.form}
                settings={settings}
                confirmationUrl={submission.confirmation_url}
            />
        </div>
    );
};

const FormThankYou = ({
    submission,
    usedGrants,
    giftCertificates,
    settings,
}) => {
    return (
        <div>
            <ThankYouTemplate
                title={
                    settings?.title ||
                    'Thank you! Your submission was successful'
                }
                description={settings?.description}
                settings={settings}
            />
            {!!usedGrants?.length && (
                <UsedPackageGrantDetails
                    grants={usedGrants}
                    token={submission.token}
                />
            )}
            {!!giftCertificates?.length && (
                <PublicGiftCertificatesList
                    giftCertificates={giftCertificates}
                    token={submission.token}
                />
            )}
        </div>
    );
};

const ThankYouConfirmation = ({ settings }) => {
    const { isBooking, events, submission, usedGrants, giftCertificates } =
        useContext(ConfirmationContext);

    clearSavedPaymentParams();

    if (isBooking) {
        return (
            <BookingThankYou
                events={events}
                submission={submission}
                settings={settings}
                usedGrants={usedGrants}
                giftCertificates={giftCertificates}
            />
        );
    } else {
        return (
            <FormThankYou
                submission={submission}
                settings={settings}
                usedGrants={usedGrants}
                giftCertificates={giftCertificates}
            />
        );
    }
};

export default ThankYouConfirmation;
